module.exports = __webpack_public_path__ + "img/2.77e08687.jpg";